import { Stack } from '@mantine/core';
import classNames from 'classnames/bind';
import { PageTitle, Panel } from 'components/index';
import { useCompanyConfiguration } from 'init/use-company-configuration';
import { i18nKeys, useTranslation } from 'locales';
import { useEffect } from 'react';
import type { RouteChildrenProps } from 'react-router';
import { accountActions } from 'store/account/account.actions';

import { INTEGRATIONS_ROUTE, Integration } from '../../Integrations.constants';
import { INTEGRATION_UPDATE_CALLBACK, IntegrationFormFieldsName } from '../Integration.constants';
import styleIdentifiers from '../Integration.module.scss';
import { useGetIntegrationRights } from '../Integration.utils';
import { IntegrationHeader } from '../IntegrationHeader';
import { DBasicsForm, type DBasicsFormFields, DBasicsFormFieldsName } from './DBasicsForm';

const styles = classNames.bind(styleIdentifiers);

export const DBasics = ({ history: { replace } }: RouteChildrenProps) => {
  const { t } = useTranslation();

  const company = useCompanyConfiguration();
  const getIntegrationRights = useGetIntegrationRights();

  const { isActive, canActivate } = getIntegrationRights(Integration.DBASICS);
  useEffect(() => {
    if (!canActivate && !isActive) {
      replace(INTEGRATIONS_ROUTE);
    }
  }, [canActivate, isActive, replace]);

  if (!company?.tp_accounting) {
    return (
      <div className={styles('loading')}>
        <div>{t(i18nKeys.LOADING)}</div>
      </div>
    );
  }

  const handleSubmit = (data: DBasicsFormFields) => {
    accountActions.updateDbasicsSettings({
      data,
      callback: INTEGRATION_UPDATE_CALLBACK,
    });
  };

  const {
    tp_accounting: {
      use_import,
      debtor_update,
      issue_date_limit,
      automatic_sync,
      use_payment_matching,
    },
  } = company;

  return (
    <>
      <PageTitle>
        <PageTitle.Back />
        {Integration.DBASICS}
        <PageTitle.Actions>
          <IntegrationHeader name={Integration.DBASICS} />
        </PageTitle.Actions>
      </PageTitle>
      <Stack>
        <Panel>
          <DBasicsForm
            onSubmit={handleSubmit}
            initialValues={{
              [DBasicsFormFieldsName.IMPORT_INTEGRATION]: use_import,
              [DBasicsFormFieldsName.PAYMENT_MATCHING]: use_payment_matching,
              [IntegrationFormFieldsName.ISSUE_DATE_LIMIT]: issue_date_limit,
              [IntegrationFormFieldsName.DEBTOR_UPDATE]: debtor_update,
              [IntegrationFormFieldsName.AUTOMATIC_SYNC]: automatic_sync,
            }}
          />
        </Panel>
      </Stack>
    </>
  );
};
